
export default {
  name: 'appHeader',
  data () {
    return {
      // n1: false,
      // n2: false,
      // n3: false
    }
  },
  mounted () {
  },
  methods: {
    handleToggleDrawer () {
      this.$parent.toggle();
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.isMobile
    },
    navList () {
      return this.$store.state.navList
    }
  }
}
